import { render, staticRenderFns } from "./LbaCustomValue.vue?vue&type=template&id=6979b601"
import script from "./LbaCustomValue.vue?vue&type=script&lang=js"
export * from "./LbaCustomValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports